import { xervixApi } from '../config/axios.config';
import { API_ROUTES } from '../constants/apiRoutes';
import { IProposalStatus, ProposalDetail } from '../types/proposal.types';

interface CreateProposal {
  serviceRequestId: string;
  proposalValue: number;
  daysToComplete: number;
  descriptionProposet: string;
}

const addProposal = async (data: CreateProposal): Promise<any> => {
  const response = await xervixApi.post(API_ROUTES.PROPOSAL.SUBMIT_PROPOSAL, data);
  return response.data;
};

/* const getProposalsByServiceRequest = async (
  serviceRequestId: string,
  pageNumber = 1,
  pageSize = 10,
  sortDirection = "desc",
  proposalStatus?: number
): Promise<any> => { */
const getProposalsByServiceRequest = async (params: IProposalStatus): Promise<any> => {
  const response = await xervixApi.get(
    API_ROUTES.PROPOSAL.FETCH_BY_SERVICE_REQUEST(params.serviceRequestId),
    {
      params: {
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
        sortDirection: "desc",
        proposalStatus: params.proposalStatus,
      },
    }
  );
  return response.data;
};

const updateProposalStatus = async (proposalId: string, proposalState: number): Promise<any> => {
  try {
    const response = await xervixApi.patch(API_ROUTES.PROPOSAL.UPDATE_STATUS(proposalId), null, {
      params: { proposalState }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getProposalDetail = async (proposalId: string): Promise<ProposalDetail> => {
  const response = await xervixApi.get(API_ROUTES.PROPOSAL.FETCH_PROPOSAL_DETAIL(proposalId));
  return response.data;
};

const downloadImageService = async (id: string): Promise<any> => {
  try {
    const response = await xervixApi.get(API_ROUTES.PROPOSAL.DOWNLOAD_IMAGE(id), {
      responseType: "blob",
      headers: {
        "Accept": "image/",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}

const methodsProposal = {
  addProposal,
  getProposalsByServiceRequest,
  updateProposalStatus,
  getProposalDetail,
  downloadImageService
};

export default methodsProposal;